// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgOpenNewWidnow = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 2.25a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6a.75.75 0 0 1 1.5 0v6A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25zm10 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V4.81l-7.72 7.72a.75.75 0 1 1-1.06-1.06l7.72-7.72H15a.75.75 0 0 1 0-1.5z"
    />
  </svg>
);
export const OpenNewWidnowIcon = forwardRef(SvgOpenNewWidnow);
